__turbopack_context__.v({
  "amount": "styles-module-scss-module__xrAhUW__amount",
  "body": "styles-module-scss-module__xrAhUW__body",
  "left": "styles-module-scss-module__xrAhUW__left",
  "right": "styles-module-scss-module__xrAhUW__right",
  "root": "styles-module-scss-module__xrAhUW__root",
  "title": "styles-module-scss-module__xrAhUW__title",
});
